import axios from "axios";
import { DateTime } from "luxon";
import md5 from "md5";
import React, { useEffect, useState } from "react";
import ReactCardFlip from "react-card-flip";
import { useSelector } from "react-redux";
import Header from "../../components/Header in Page/_Header";
import NewHeader from "../../components/New Header/NewHeader";
import "../Lettura/_newLetture.scss";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardControlKeyIcon from "@mui/icons-material/KeyboardControlKey";
import ArrowForwardIos from "@mui/icons-material/ArrowForwardIos";
import Autolettura from "./steps/Autolettura";
import Skeleton from "@mui/material/Skeleton";
import RecapLettura from "./steps/RecapLettura";

function NewLettureGas() {
    const customerCode = useSelector((user) => user.gas.info.customer_code)
    const customerId = useSelector((user) => user.gas.info.customer_id)
  const pdr = useSelector((user) => user.gas.info.pod_code);
  const tknPvt = md5(customerId + 'oYmAIdtki%lu')
  const [overlay, setOverlay] = useState(false);
  const [letture, setLetture] = useState();
  const [autoLetture, setAutoLetture] = useState();
  const [counter, setCounter] = useState(6);
  const podCode = useSelector((user) => user.user.info.pod_code);
  const [flipped, setFlipped] = useState(false);
  const [data, setData] = useState({});
  const [step, setStep] = useState(0);
  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.style.overflow = "hidden";
    document.body.style.touchAction = "none";
    init();
    getAutoletture();
  }, [counter, overlay]);

  const init = async () => {
    const deliveryApi = `https://my.revoluce.it/area_utente/gestione/api/deliveries/getDeliveryGas.php?codice_cliente=${customerCode}`
    const { data } = await axios.get(deliveryApi)
    setLetture(data.data.reverse().slice(0, 12));
  }

  const getAutoletture = async () => {
    const autolettureApi = `https://my.revoluce.it/area_utente/gestione/api/deliveries/getAutolettureGas.php?customer_id=${customerId}&tkn_pvt=${tknPvt}&pdr=${pdr}`
    const { data } = await axios.get(autolettureApi)
    setAutoLetture(data.data.reverse().slice(0,12))
  }
  const handleOverlay = () => {
    setOverlay(!overlay);
  };
  return (
    <div className="letture gas">
      <div className="letture-top">
        <NewHeader
          logo="white"
          padding="no"
          iconsColor="white"
          overlay={overlay}
          overlayTitle="Indietro"
          setOverlay={setOverlay}
        />
      </div>
      {!overlay ? (
        <div className="letture-bottom">
          <Header
            title={overlay ? "Autoletture" : "Letture"}
            description={
              !overlay
                ? ` Nella tabella qui in basso troverai le ultime letture reali relative al codice PDR ${pdr}, dalla più recente alla meno recente.`
                : null
            }
            icon="let"
          />
          <div className="switchLettura" onClick={() => setFlipped(!flipped)}>
            {flipped ? (
              <p>Vai alle tue letture</p>
            ) : (
              <p>Vai alle tue autoletture</p>
            )}
          </div>
          <ReactCardFlip isFlipped={flipped} flipDirection="horizontal">
            <div className="lettureBox">
              <div className="headerBox">
                <ul>
                  <li>Data</li>
                  <li>Precedente</li>
                  <li>Attuale</li>
                  <li>TOT</li>
                </ul>
              </div>
              <div className="bodyBox">
                  
                {letture && letture ? (
                  letture.slice(0, counter).map((r) => (
                    <div className="line" key={r.pod_id}>
                      <ul>
                        <li>
                          {DateTime.fromISO(r.mese, { locale: "it" }).toFormat(
                            `MMMM`
                          )}
                        </li>
                        <li>{parseFloat(r.let_prec)}</li>
                        <li>{parseFloat(r.let_att)}</li>
                        <li>{parseFloat(r.consumo_mc)}</li>
                      </ul>
                    </div>
                  ))
                ) : (
                  <div
                    className="line"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <Skeleton variant="text" width={200} />
                    <Skeleton variant="text" width={200} />
                    <Skeleton variant="text" width={200} />
                    <Skeleton variant="text" width={200} />
                    <Skeleton variant="text" width={200} />
                    <Skeleton variant="text" width={200} />
                  </div>
                )}
              </div>
              <div className="moreInfo">
                <p
                  className="more"
                  onClick={() =>
                    counter === 6 ? setCounter(12) : setCounter(6)
                  }
                >
                  {counter === 6 ? "Mostra di più" : "Mostra meno"}
                  {counter === 6 ? (
                    <KeyboardArrowDownIcon />
                  ) : (
                    <KeyboardControlKeyIcon />
                  )}
                </p>
              </div>
            </div>
            <div className="lettureBox">
              <div className="headerBox">
                <ul>
                  <li>Data</li>
                  <li>Letture</li>
                </ul>
              </div>
              <div className="bodyBox">
                {autoLetture && autoLetture.slice(0,counter).map((r) => (
                  <div className="line" key={r.pod_id}>
                    <ul>
                      <li>{DateTime.fromISO(r.giorno, {locale: 'it'}).toFormat(`MMMM`)}</li>
                      <li>{parseFloat(r.lettura)}</li>
                    </ul>
                  </div>
                ))}
              </div>
              <div className="moreInfo">
                <p
                  className="more"
                  onClick={() =>
                    counter === 6 ? setCounter(12) : setCounter(6)
                  }
                >
                  {counter === 6 ? "Mostra di più" : "Mostra meno"}
                  {counter === 6 ? (
                    <KeyboardArrowDownIcon />
                  ) : (
                    <KeyboardControlKeyIcon />
                  )}
                </p>
              </div>
            </div>
          </ReactCardFlip>
          <div className="buttonContainer" onClick={() => handleOverlay()}>
            <button>
              Invia autolettura <ArrowForwardIos />
            </button>
          </div>
          <div className="emptyBox" style={{ height: "100px" }}></div>
        </div>
      ) : (
        <div className="letture-bottom">
          {step === 0 ? (
            <>
              <Header
                title="Autoletture"
                description={`Nella tabella qui in basso troverai le ultime letture reali relative al codice POD ${
                  podCode && podCode
                }, dalla più recente alla meno recente, divise per fasce. Ti ricordo che:`}
              />
              <Autolettura
                setData={setData}
                data={data}
                setStep={setStep}
                step={step}
              />
              <div className="emptyBox" style={{ height: "100px" }}></div>
            </>
          ) : (
            <RecapLettura data={data} />
          )}
        </div>
      )}
    </div>
  );
}

export default NewLettureGas;
